import { MutationTree } from 'vuex';

// Shared types
import { RequestSpace, OfferRequestAdditionalProduct, RequestOfferRequest } from '@coldtec/cos-types';

// Store types
import { RootState, RequestMutation } from '@/store/store.types';

/**
 *  Holding all the mutations of the spaces.
 */
export const Mutations: MutationTree<RootState> = {

    /**
     *  Used to store the valid state of the request.
     */
    [RequestMutation.VALID](state: RootState, valid: boolean): void {

        state.request.valid = valid;

    },

    /**
     *  Used to (re)store the data of a request that is retrieved from the API.
     */
    [RequestMutation.REQUEST](state: RootState, request: RequestOfferRequest): void {

        /**
         *  An address is only saved if installation is requested.
         */
        request.address = request.address ?? {
            streetname: '',
            house_number: '',
            zipcode: '',
            city: '',
        };

        state.request.data = request;

    },

    /**
     *  Used to store the guid of the request which was (re)stored from the API.
     */
    [RequestMutation.REQUEST_GUID](state: RootState, requestGuid: string): void {

        state.request.guid = requestGuid;

    },

    /**
     *  Used to store the currently added spaces (refs) that are added to the request.
     */
    [RequestMutation.SPACES](state: RootState, spaces: Array<RequestSpace>): void {

        state.request.data.spaces = spaces;

    },

    /**
     *  Used to store the service products (guids) that are added to the request.
     */
    [RequestMutation.PRODUCTS_SERVICE](state: RootState, serviceProductGuids: Array<string>): void {

        state.request.data.service_products = serviceProductGuids;

    },

    /**
     *  Used to store the additional products that are added to the request.
     */
    [RequestMutation.PRODUCTS_ADDITIONAL](state: RootState, additionalProducts: Array<OfferRequestAdditionalProduct>): void {

        state.request.data.additional_products = additionalProducts;

    },

};
